import { useTranslation } from 'react-i18next';
import { ReactComponent as EyeIcon } from 'assets/icons/eye.svg';
import IconButton from 'components/IconButton/IconButton';
import Table from 'components/Table/Table';
import TableBody from 'components/Table/TableBody';
import TableCell from 'components/Table/TableCell';
import TableHead from 'components/Table/TableHead';
import TableRow from 'components/Table/TableRow';
import { TASK_HEAD_INFO_CELLS } from 'constants/dataSets';
import { TASK_PRIORITY_OPTIONS } from 'constants/taskPriority';
import formattedData from 'utils/formattedData';

import type { TTaskStatus } from 'constants/interfaces';
import type ITaskInfoTable from './interfaces/ITaskInfoTable';

import styles from './sass/TaskInfoTable.module.scss';

function TaskInfoTable({
  dataTable,
  onGoToTask,
  getStatusClassName,
  className,
}: ITaskInfoTable) {
  const { t } = useTranslation();

  return (
    <div className={`${styles.tableContainer} ${className || ''}`}>
      <p className={styles.tableTitle}>{t('taskManagement.tableTitle')}</p>
      <div className={styles.tableWrapper}>
        {dataTable.length > 0 && dataTable?.length > 0 ? (
          <Table className={styles.table}>
            <TableHead className={styles.header}>
              {TASK_HEAD_INFO_CELLS.map(({
                id, label,
              }) => (
                <TableCell
                  head
                  className={`${styles.tableCell} ${id === 'actions' ? styles.actionHeaderCell : ''}`}
                  key={id}
                >
                  <div>
                    <span>{t(label)}</span>
                  </div>
                </TableCell>
              ))}
            </TableHead>
            <TableBody className={styles.body}>
              {dataTable?.map((task) => (
                <TableRow key={task.id}>
                  <TableCell className={styles.nameCell}>{task.title}</TableCell>
                  <TableCell className={styles.assignedUsersCell}>
                    {task?.assignedUsers?.length > 0 ? task?.assignedUsers.map((user) => (
                      <div className={styles.assignedUser} key={[user?.id, user?.firstName, user?.lastName].join('_')}>
                        <span>{`${user?.firstName} ${user?.lastName}`}</span>
                        <span className={styles.email}>{user?.email}</span>
                      </div>
                    )) : '-'}
                  </TableCell>
                  <TableCell>{formattedData(task.createdAt || '-', true) || '-'}</TableCell>
                  <TableCell>{formattedData(task.startDate || '-', true) || '-'}</TableCell>
                  <TableCell>{formattedData(task.endDate || '-', true) || '-'}</TableCell>
                  <TableCell className={styles.priorityCell}>
                    {TASK_PRIORITY_OPTIONS.find((option) => option.value === task.priority)?.icon}
                    <span className={styles.label}>
                      {TASK_PRIORITY_OPTIONS.find((option) => option.value === task.priority)?.label}
                    </span>
                  </TableCell>
                  <TableCell>
                    <div className={getStatusClassName(task.status as TTaskStatus)}>
                      {task.status as TTaskStatus}
                    </div>
                  </TableCell>
                  <TableCell>
                    <IconButton
                      icon={<EyeIcon />}
                      onClick={() => onGoToTask(`${task.id}`)}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : null}
      </div>
    </div>
  );
}

export default TaskInfoTable;
